import { getUuid } from '@sibe/utilities/common';
import { HsGeometryType } from '../../graphic-engine-new/geometry/geometry-type.enum';
import { HsRegularGeometry } from '../../graphic-engine-new/geometry/regular-geometry.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import { HsBox } from '../../math-new/shapes/box.class';
import { HsSphere } from '../../math-new/shapes/sphere.class';

/**
 * A point cloud geometry with float32 positions followed by one RGB byte triple per point: 15 bytes per
 * point instead of the 24 of `hsMakeGeometry`, so a frame of millions of points reads 40% fewer vertex
 * bytes. `colors` holds `positions.length` bytes.
 */
export function hsMakePointCloudGeometry(
  graphics: HsGraphics,
  positions: ArrayLike<number>,
  colors: Uint8Array
): HsRegularGeometry | null {
  const vertices: Float32Array = positions instanceof Float32Array ? positions : Float32Array.from(positions);
  if (colors.length !== vertices.length) {
    return null;
  }
  const box: HsBox = HsBox.makeFromArray(vertices);
  const sphere: HsSphere = HsSphere.makeSphereFromBoundingBox(box.min, box.max);
  const bufferArray: Uint8Array = new Uint8Array(vertices.byteLength + colors.byteLength);
  bufferArray.set(new Uint8Array(vertices.buffer, vertices.byteOffset, vertices.byteLength));
  bufferArray.set(colors, vertices.byteLength);
  const buffer: HsGraphicsBuffer | null = graphics.createBuffer(bufferArray);
  if (buffer === null) {
    return null;
  }
  return new HsRegularGeometry(getUuid(), HsGeometryType.Triangles, box, sphere, vertices.length, 0, buffer, 'rgb8');
}
